import { useEffect, useState } from 'react'
import { Form, Button, Tooltip, notification } from "antd"
import {
  CheckOutlined,
  DislikeOutlined,
  EditOutlined,
  LikeOutlined,
  SaveOutlined
} from "@ant-design/icons"

const INTERVENTION_CREATOR_ROLE = 'InterventionCreator';
const INTERVENTION_APPROVER_ROLE = 'InterventionApprover';

const ActionButtons = ({ form, rowIndex, setExpandedRowKey, setActive, active, editable, secondaryAction }) => {

  const [gereed, setGereed] = useState(false)
  const [akkoord, setAkkoord] = useState(false)
  const [roleAllowsCreation, setRoleAllowsCreation] = useState(false)
  const [roleAllowsAkkoord, setRoleAllowsAkkoord] = useState(false)

  useEffect(() => {
    (async () => {
      const { intervention } = form.getFieldsValue().interventions[rowIndex]
      if (intervention == undefined) {
        return;
      }
      const n = await intervention.load()
      setGereed(n.get('http://pms.coentunnelcompany.nl/rdl#ready'))
      setAkkoord(n.get('http://pms.coentunnelcompany.nl/rdl#affirmed'))
    })()
  }, [])

  useEffect(() => {
    (async () => {
      const roles = await Weaver.getInstance().currentUser().getRoles();
      roles.forEach((role) => {
        if(role.name() === INTERVENTION_CREATOR_ROLE) {
          setRoleAllowsCreation(true);
        }
        if(role.name() === INTERVENTION_APPROVER_ROLE) {
          setRoleAllowsAkkoord(true);
        }
      })
    })()
  }, [])

  const ButtonItem = ({ children, tooltip, ...props }) => (
    <Form.Item noStyle>
      <Tooltip title={tooltip}>
        <Button
          style={{
            margin: '0px 10px',
            flex: 1
          }}
          { ...props}
        >
          { children }
        </Button>
      </Tooltip>
    </Form.Item>
  )

  const renderEditSave = () => (
    rowIndex === active
    ?
    <ButtonItem
      disabled={!roleAllowsCreation || gereed || akkoord}
      tooltip={roleAllowsCreation?'':'Vereist rol InterventionCreator'}
      type="primary"
      htmlType="submit"
      icon={<SaveOutlined />}
    >Opslaan</ButtonItem>
    :
    <ButtonItem
      disabled={!roleAllowsCreation || gereed || akkoord}
      tooltip={roleAllowsCreation?'':'Vereist rol InterventionCreator'}
      type="primary"
      onClick={() =>{
        setActive(rowIndex)
        setExpandedRowKey(rowIndex)
      }}
      icon={<EditOutlined />}
    >Bewerk</ButtonItem>
  )

  const renderGereedAkkoord = () => (
    gereed === false || gereed === undefined
    ?
    <ButtonItem
      disabled={!roleAllowsCreation || rowIndex === active}
      tooltip={roleAllowsCreation?'':'Vereist rol InterventionCreator'}
      onClick={async () => {
        try {
          const activeRow = form.getFieldsValue().interventions[rowIndex]
          activeRow.intervention.set('http://pms.coentunnelcompany.nl/rdl#ready', true)
          await activeRow.intervention.save()
          setGereed(true)
        } catch(e) {
          console.error(e)
        }
      }}
      icon={<CheckOutlined />}
    >Gereed</ButtonItem>
    :
    <>
      <ButtonItem
        onClick={async () => {
          try {
            const activeRow = form.getFieldsValue().interventions[rowIndex]
            await secondaryAction(activeRow.intervention)
            activeRow.intervention.set('http://pms.coentunnelcompany.nl/rdl#affirmed', true)
            await activeRow.intervention.save()
            setAkkoord(true)
          } catch(e) {
            notification.error({
              style: {whiteSpace: 'pre-wrap'},
              message: 'Deze interventie bevat een fout',
              description: e.message,
              duration: 10
            })
          }
        }}
        style={akkoord === true ? { background: '#58bd91', color: '#fff' } : null}
        disabled={!roleAllowsAkkoord || akkoord === true}
        tooltip={(roleAllowsAkkoord || akkoord === true)?'':'Vereist rol InterventionApprover'}
        icon={<LikeOutlined />}
        type="text"
      >
        Akkoord
      </ButtonItem>
      <ButtonItem
        danger
        type="text"
        onClick={async () => {
          try {
            const activeRow = form.getFieldsValue().interventions[rowIndex]
            activeRow.intervention.set('http://pms.coentunnelcompany.nl/rdl#ready', false)
            activeRow.intervention.set('http://pms.coentunnelcompany.nl/rdl#affirmed', false)
            await activeRow.intervention.save()
            setGereed(false)
            setAkkoord(false)
          } catch(e) {
            console.error(e)
          }
        }}
        disabled={!roleAllowsAkkoord || akkoord === true}
        tooltip={(roleAllowsAkkoord || akkoord === true)?'':'Vereist rol InterventionApprover'}
        icon={<DislikeOutlined />}
      >
        Verwerp
      </ButtonItem>
    </>
  )

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'space-around',
      alignItems: 'center'
    }}>
      { editable ? renderEditSave() : null }
      { renderGereedAkkoord() }
    </div>
  )
}

export default ActionButtons
